export default "__VITE_ASSET__BVoDFLxc__"